export function findObjectsByUserDataProperty<T extends THREE.Object3D>(
  scene: THREE.Scene,
  propertyName: string,
  propertyValue: any
): T | null {
  let foundObject = null;
  scene.traverse((object: THREE.Object3D) => {
    if (
      object.userData &&
      object.userData.hasOwnProperty(propertyName) &&
      object.userData[propertyName] === propertyValue
    ) {
      foundObject = object as T;
    }
  });
  return foundObject;
}
